import { spawn, call, put, takeLatest } from 'redux-saga/effects';
import { createAction } from '@reduxjs/toolkit';
import { clientActions } from '../../../application/actions/client';

import api from '../../api/index';

const apiRequest = api(process.env.REACT_APP_HOST);


// GETALL
export function* getAllFetch() {
    yield put(clientActions.conexionGetAll({connection:true}));
    try {
        const url = `client`
        const response = yield call(
            apiRequest.get,
            url,
        );

        // Extraigo todos los datos
        const { data } = response;
        yield put(clientActions.getAll({data}));
    } catch (err) {
        yield put(clientActions.errorGetAll({error:true, message:err.message}));
    } finally {
        yield put(clientActions.conexionGetAll({connection:false}));
    }
}

// GETBYID
export function* getByIdFetch(e) {
    yield put(clientActions.conexionGetById({connection:true}));
    try {
        const  params  = e.payload;
        const url = `client/${params.id}`
        const response = yield call(
            apiRequest.get,
            url,
        );

        // Extraigo todos los datos
        const { data } = response;
        yield put(clientActions.getById({data}));
    } catch (err) {
        yield put(clientActions.errorGetById({error:true, message:err.message}));
    } finally {
        yield put(clientActions.conexionGetById({connection:false}));
    }
}

// CREATE
export function* createFetch(e) {
    yield put(clientActions.conexionCreate({connection:true}));
    try {
        const  params  = e.payload;
        const url = `client`
        const response = yield call(
            apiRequest.post,
            url,
            params
        );

        // Extraigo todos los datos
        const { result } = response;
        yield put(clientActions.create({result}));
    } catch (err) {
        yield put(clientActions.errorCreate({error:true, message:err.message}));
    } finally {
        yield put(clientActions.conexionCreate({connection:false}));
    }
}
// UPDATE
export function* updateFetch(e) {
    yield put(clientActions.conexionUpdate({connection:true}));
    try {
        const  params  = e.payload;
        const url = `client/${params.id}`
        const response = yield call(
            apiRequest.put,
            url,
            params
        );

        // Extraigo todos los datos
        const { result } = response;
        yield put(clientActions.update({result}));
    } catch (err) {
        yield put(clientActions.errorUpdate({error:true, message:err.message}));
    } finally {
        yield put(clientActions.conexionUpdate({connection:false}));
    }
}

export function* watchFetchSesion() {
    yield takeLatest(clientActionsSaga.getAll.type,  getAllFetch);
    yield takeLatest(clientActionsSaga.getById.type,  getByIdFetch);
    yield takeLatest(clientActionsSaga.create.type,  createFetch);
    yield takeLatest(clientActionsSaga.update.type,  updateFetch);
}

export default function* rootSaga() {
    yield spawn(watchFetchSesion);
}


const getAll = createAction('clientSaga/getAll');
const getById = createAction('clientSaga/getById');
const create = createAction('clientSaga/create');
const update = createAction('clientSaga/update');

export const clientActionsSaga = {
    getAll,
    getById,
    create,
    update
};
